/*
 * ******************************************************************
 * Copyright (c) 2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

// Empty stand-in for optional modules that aren't installed (e.g. lunr-languages), so
// webpack can resolve their imports without the dependency actually being present.
// See tsconfig.json "paths" for the aliases pointing here.
// Must be a callable no-op: consumers (e.g. ngx-contextual-help) call each language
// module directly as a stemmer-registration function, e.g. `de(elasticlunrjs)`.
export default function() {};
